'use client';

import clsx from 'clsx';
import { FC, useState } from 'react';

import { Icon } from '@/general/Icons/Icon';
import { Shade } from '@/general/components/Shade/Shade';
import { useRouter } from '@/general/helpers/useRouter';
import { camelToKebab, getPlpSlugFromParams, kebabToCamel } from '@/plp/helpers/getPlpSlug';
import { sortValuesList, sortValuesListKeys } from '@/types/CarFilters.types';

import { FilterParams } from '../PlpFilters/PlpFilters.type';

interface Props {
  plpParams?: FilterParams;
}

export const PlpSort: FC<Props> = ({ plpParams = { filter: '' } }) => {
  const router = useRouter();
  const [value, setValue] = useState<string>(kebabToCamel(plpParams?.sort ?? ''));

  const handleChangeSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (typeof window !== 'undefined' && event.target.value !== value) {
      const newUrl = getPlpSlugFromParams({
        ...plpParams,
        sort: camelToKebab(event.target.value),
        page: '1',
      });
      setValue(event.target.value);
      router.push(newUrl);
    }
  };

  return (
    <label className="flex items-center justify-end">
      <span className="whitespace-nowrap">Sort by:&ensp;</span>
      <span className="sr-only">{value}</span>
      <span className={clsx('relative flex items-center overflow-hidden rounded-md', 'c-shade_container')}>
        <select
          className={clsx(
            'button button--small button--secondary',
            'pointer-events-auto! block py-1.5! pr-10! leading-6!',
          )}
          value={value}
          onChange={handleChangeSelect}
          data-testid="sort-trigger"
        >
          {sortValuesListKeys.map((item) => (
            <option key={item} value={item} data-testid={`SortMenuItem-${item}`}>
              {sortValuesList[item]}
            </option>
          ))}
        </select>
        <Shade useParent className="pointer-events-none before:hidden" />
        <span className="relative -ml-6 h-6 w-6 -translate-x-2 text-for-pri-bas">
          <Icon name="sort" />
        </span>
      </span>
    </label>
  );
};
